// @flow

import styled, { css } from 'styled-components';
import media from '../../helpers/media';
import type { Props } from './types';
import type { Theme } from '../../types';

const Container = styled<any, Theme, Props>('div')`
  max-width: 100%;
  margin-left: auto;
  margin-right: auto;
  width: 100%;

  ${props => !props.notOnSm && props.theme.grid.container.sm && media.sm(css`
    width: ${props.theme.grid.container.sm};
  `)}
  ${props => !props.notOnMd && props.theme.grid.container.md && media.md(css`
    width: ${props.theme.grid.container.md};
  `)}
  ${props => !props.notOnLg && props.theme.grid.container.lg && media.lg(css`
    width: ${props.theme.grid.container.lg};
  `)}
  ${props => !props.notOnXl && props.theme.grid.container.xl && media.xl(css`
    width: ${props.theme.grid.container.xl};
  `)}
`;

export default Container;
